import { render } from "./App.vue?vue&type=template&id=12bd5ef0"
const script = {}

import "./App.vue?vue&type=style&index=0&id=12bd5ef0&lang=css"

import exportComponent from "E:\\workshop\\workshop.vue\\v3.jiatengbus.com\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__